// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1odTQ","checkboxCol":"Table_checkboxCol__2Gr6Z","emailCol":"Table_emailCol__2Ipio","actionCol":"Table_actionCol__3JTw0"};